const API_BASE = import.meta.env.VITE_API_URL || "https://api.appagronegocios.com.br";

export const links = {
  partnerSignup: `${API_BASE}/cadastro-empresa`,
  privacy: `${API_BASE}/privacidade`,
  terms: `${API_BASE}/termos`,
  whatsapp: "https://wa.me/5566999842002",
  instagram: "https://www.instagram.com/app_agro_negocios",
  phoneDisplay: "(66) 99984-2002",
  phoneHref: "tel:+5566999842002",
  email: "contato@appagronegocios.com.br",
};

export const appPublished = false;
